(ns ui.view.grid-opensearch.model)

(def root-path [::state])

(def filters-key :filters)
(def config-key :config)
(def data-key :data)
(def pipeline-key :pipeline)
(def entity-type-key :entity-type)
(def accessible-field-paths-key :accessible-field-paths)
(def ag-api-key :ag-api)
(def external-filters-key :external-filters)
(def external-filter-context-key :external-filter-context)
(def external-query-text-key :external-query-text)
(def group-value-mapping-key :group-value-mapping)
(def last-query-key :last-query)
(def total-key :total)

(defn grid-path
  [grid-id]
  (into root-path [grid-id]))

(defn ag-grid-api-full-path
  [grid-id]
  (into root-path [grid-id ag-api-key]))

(defn external-filters-full-path
  [grid-id]
  (into root-path [grid-id external-filters-key]))

(defn external-filter-context-full-path
  [grid-id]
  (into root-path [grid-id external-filter-context-key]))

(defn external-query-text-full-path
  [grid-id]
  (into root-path [grid-id external-query-text-key]))

(defn group-value-mapping-full-path
  ([grid-id]
   (into root-path [grid-id group-value-mapping-key]))
  ([grid-id group-alias]
   (into root-path [grid-id group-value-mapping-key group-alias])))

(defn last-query-full-path
  "The query behind the rows the grid shows now: the OpenSearch clauses, the
   requested fields and the total hit count. A selection of all rows is
   resolved against this query."
  [grid-id]
  (into root-path [grid-id last-query-key]))

(defn last-query-total-full-path
  [grid-id]
  (into root-path [grid-id last-query-key total-key]))

(defn filters-full-path
  [grid-id]
  (into root-path [grid-id filters-key]))

(defn config-full-path
  [grid-id]
  (into root-path [grid-id config-key]))

(defn data-full-path
  [grid-id]
  (into root-path [grid-id data-key]))

(defn entity-type-full-path
  [grid-id]
  (into root-path [grid-id entity-type-key]))

(defn pipeline-full-path
  [grid-id]
  (into root-path [grid-id pipeline-key]))

;; grid-opensearch.config
(def column-registry
  {::column
   [:or
    keyword?
    [:vector [:ref ::column]]]})

(def Column
  "Logical column path:

   - keyword?                         => simple field, e.g. :screening-profile/name
   - vector of Column                 => nested path/group
     e.g. [:screening-profile/name
           [:screening-profile/target :asset/name]]"
  [:schema {:registry column-registry}
   ::column])

(def Config
  "Persisted grid configuration for a single entity+grid.

  - :columns   – ordered list of logical field paths
                 (keyword or [keyword ...] path)
  - :sorted-by – optional list of sort descriptors, in priority order.
                 Each has logical field-path and direction.

  Everything else (os-fields, ag-grid colDefs, filters, pipeline-id)
  is runtime-only and derived from these + entity schema."
  [:map
   [:columns
    [:sequential Column]]

   [:hidden-columns {:optional true} [:set Column]]
   [:pinned-columns {:optional true} [:set Column]]

   [:sorted-by
    {:optional true}
    [:sequential
     [:map
      [:field-path Column]
      [:direction [:enum :asc :desc]]]]]])
